import styled from '@emotion/styled';
import { Icon, tokens } from '@hotjar/hotsauce';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${tokens.spacer.x0pt5};
  color: ${tokens.color.text_danger};
  ${tokens.text('subtitle2')}
  line-height: 14px;
`;

const TrendIcon = styled(Icon)`
  padding-inline-end: 0px;
  height: 12px;
  width: 12px;
  min-width: 12px;
  min-height: 12px;
`;

type Props = {
  value: number;
};

export function Trend({ value }: Props): JSX.Element {
  return (
    <Wrapper>
      <TrendIcon icon="arrow_down_alone" />
      <span>{value}%</span>
    </Wrapper>
  );
}
